// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__138CW","content":"styles_content__1pwUH"};